import gql from "graphql-tag";

export const amsPaginationMessages = gql`
  query amsPaginationMessages(
    $token: String!
    $stationId: String!
    $page: Int
    $pageCount: Int
  ) {
    amsPaginationMessages(
      token: $token
      stationId: $stationId
      page: $page
      pageCount: $pageCount
    ) {
      objects {
        id
        measuredAt
        dd
        ff
        TTT1
        P0P0P0P03
        PPPP4
        ppp5
        RRR6
        batteryCharge
      }
      page
      pages
      hasNext
      hasPrev
    }
  }
`;

export const levelsLastMessages = gql`
  query levelsLastMessages($token: String!) {
    levelsLastMessages(token: $token, isadmin: true) {
      message {
        id
        measuredAt
      }
      station {
        name
        lat
        lon
        height
        id
      }
    }
  }
`;

export const levelsPaginationMessages = gql`
  query levelsPaginationMessages(
    $token: String!
    $stationId: String!
    $page: Int
    $pageCount: Int
    $filterSort: FilterSortInput
  ) {
    levelsPaginationMessages(
      token: $token
      stationId: $stationId
      page: $page
      pageCount: $pageCount
      filterSort: $filterSort
    ) {
      objects {
        id
        measuredAt
        LW
        TW
        LWBS
        LWAB
      }
      page
      pages
      hasNext
    }
  }
`;

export const levelsStations = gql`
  query levelsStations($token: String!) {
    levelsStations(token: $token) {
      name
      id
      lat
      lon
    }
  }
`;
